'use client';

import { AdWrapper } from '@/components/Ads';

export default function ForumsAdLayout({ children }: { children: React.ReactNode }) {
  return (
    <AdWrapper showSideAds={true} showLeftSideAd={true} showBottomAd={true}>
      {children}
    </AdWrapper>
  );
}
